import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ListChecks } from 'lucide-react';
import { IncidentIndicators } from './IncidentIndicators';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/rules')({
    staticData: {
        metadata: {
            title: 'Rules',
        },
        ui: {
            icon: ListChecks,
            title: 'Incident rules',
            subtitle: 'Indicator rules that flag incidents by milestone and timing',
            menuDescription: 'Indicator rules that flag incidents by milestone and timing',
        },
    },
    component: IncidentRules,
});

function IncidentRules() {
    return (
        <PageController route={Route}>
            <IncidentIndicators />
        </PageController>
    );
}
